import { isDarkMode } from '@localstack/services';
import { Box, FormControlLabel, styled } from '@mui/material';
import { blueGrey, grey } from '@mui/material/colors';
import { Theme } from '@mui/material/styles';

export const SELECTED_OPTION_CLASS = 'selectedOption';

export const optionBorderColor = (theme: Theme): string => (isDarkMode(theme) ? grey[800] : grey[300]);

const optionBorder = (theme: Theme): string => `1px solid ${optionBorderColor(theme)}`;

export const OptionList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  border: optionBorder(theme),
  borderRadius: '6px',
  overflow: 'hidden',
}));

export const OptionRow = styled(FormControlLabel)(({ theme }) => ({
  borderBottom: optionBorder(theme),
  padding: `${theme.spacing(0.25)} ${theme.spacing(1.5)}`,
  paddingRight: theme.spacing(0.5),
  margin: 0,
  transition: 'all .2s ease-in-out',
  textAlign: 'left',
  alignItems: 'flex-start',
  '&:last-child': {
    borderBottom: 'none',
  },
  '&:hover': {
    background: isDarkMode(theme) ? blueGrey[900] : grey[100],
  },
  '& .MuiFormControlLabel-label': {
    flex: 1,
  },
  [`&.${SELECTED_OPTION_CLASS}`]: {
    background: theme.palette.background.default,
  },
}));
